<template>
    <div class="flex justify-between items-center">
        <div>
            <h1 class="my-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
                {{ fixture.title }}
            </h1>
            <h2 class="mb-2 text-md font-medium leading-7 text-gray-500 sm:truncate">
                <span v-if="fixture.starts_at !== null">{{
                        moment(fixture.starts_at, 'YYYY-MM-DD').format('dddd Do MMMM YYYY')
                    }}
                | </span>{{ fixture.type.name }}</h2>
        </div>
        <div class="text-right text-sm">
            <p><strong>Client:</strong> {{ fixture.client.name }}</p>
            <p><strong>Fixture Reference:</strong> {{ fixture.reference }}</p>
            <slot name="info"></slot>
            <p class="flex justify-content-end justify-end">
                <strong class="mr-1">Fixture Status:</strong>
                <span v-if="fixture.status === 'Request'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                        fixture.status
                    }} </span>
                <span v-if="fixture.status === 'Cost'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-yellow-100 text-yellow-800"> {{
                        fixture.status
                    }} </span>
                <span v-if="fixture.status === 'Cancelled'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-red-100 text-red-800"> {{
                        fixture.status
                    }} </span>
                <span v-if="fixture.status === 'Complete'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-green-100 text-green-800"> {{
                        fixture.status
                    }} </span>
            </p>
        </div>
    </div>
    <div class="flex justify-between">
        <FixtureTabs/>
        <slot name="actions"></slot>
    </div>
</template>


<script>

import FixtureTabs from "@/Components/FixtureTabs";
import moment from "moment/moment";

export default {
    components: {
        FixtureTabs
    },
    props: {
        fixture: Object
    },
    created() {
        this.moment = moment
    }
}

</script>
